import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "MyTrumpf/Partial Templates/Overview Header",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const OverviewHeaderIntroRow = (data) =>
    html`
        <div class="ux-row ux-u-flex-ai-center ux-u-flex-jc-between ux-u-py-m">
            <div
                class="ux-col-12 ${data.buttonLabelEcat
                    ? "ux-col-lg-auto"
                    : "ux-col-md-auto"}  ux-u-mb-lg-zero ux-u-d-flex ux-u-flex-jc-center ux-u-flex-jc-lg-start"
            >
                <h1
                    class="ux-text-headline ux-text-headline--giant ux-u-mt-zero ux-u-mb-zero"
                >
                    ${data.headline}
                </h1>
            </div>
            ${data.type === "my-machine" ? MyMachinesContent(data) : ""}
            ${data.type === "my-software" ? MySoftwareContent(data) : ""}
            ${data.type === "my-service-cases"
                ? MyServiceCasesContent(data)
                : ""}
            ${(data.type === "my-orders" || data.type === "my-missions") &&
            !data.empty
                ? SingleSearchFielContent(data)
                : ""}
        </div>
    `;

const MyMachinesContent = (data) =>
    html`${data.buttonLabelEcat
        ? html`<div
              class="ux-col-12 ux-col-sm-10 ux-col-md-8 ux-col-lg-auto ux-u-offset-sm-1 ux-u-offset-md-2 ux-u-offset-lg-0 ux-u-d-flex ux-u-flex-ai-center"
          >
              <div class="ux-row ">
                  <ux-button
                      class="ux-col ux-col-md-6 ux-col-lg-auto ux-u-d-flex ux-u-mt-xs ux-u-mt-lg-zero"
                      data-trigger-async-modal="open,request-e-catalog-stateful"
                  >
                      ${data.buttonLabelEcat}</ux-button
                  >
                  <ux-button
                      class="ux-col-auto ux-col-md-6 ux-col-lg-auto ux-u-mt-xs ux-u-mt-lg-zero"
                      icon="plus"
                      label-visibility="m"
                      icon-placement="end"
                      data-trigger-async-modal="open,add-machine"
                      >${data.buttonLabel}
                  </ux-button>
                  ${!data.empty
                      ? html`<ux-iws-stateful-filter-search
                            class="ux-col-12 ux-col-lg-auto ux-u-mt-xs ux-u-mt-lg-zero ux-u-mb-zero"
                            name="search"
                            placeholder="${data.searchPlaceholder ||
                            "Suchbegriff eingeben"}"
                            scope="my-machine"
                            debug
                        ></ux-iws-stateful-filter-search>`
                      : ""}
              </div>
              <ux-iws-async-modal
                  name="request-e-catalog-stateful"
                  src="mock-data/e-catalog/e-cat-stateful-modal-step-1.html"
              ></ux-iws-async-modal>
              <ux-iws-async-modal
                  name="add-machine"
                  src="mock-data/my-machine/add-new-machine.html"
              ></ux-iws-async-modal>
          </div>`
        : html`
              <div class="ux-col-lg-auto">
                  <div class="ux-row">
                      <ux-button
                          class="ux-col-auto ux-col-sm ux-u-mt-xs ux-u-mt-lg-zero"
                          icon="plus"
                          icon-placement="end"
                          label-visibility="s"
                          data-trigger-async-modal="open,add-machine"
                      >
                          ${data.buttonLabel}</ux-button
                      >
                      ${!data.empty
                          ? html`<ux-iws-stateful-filter-search
                                class="ux-col ux-col-lg-auto ux-u-mt-xs ux-u-mt-lg-zero ux-u-mb-zero"
                                name="search"
                                placeholder="${data.searchPlaceholder ||
                                "Suchbegriff eingeben"}"
                                scope="my-machine"
                                debug
                            ></ux-iws-stateful-filter-search>`
                          : ""}
                  </div>
              </div>
          `}`;

const MyServiceCasesContent = (data) => html`<div class="ux-col-lg-auto">
    <div class="ux-row">
        <ux-button
            class="ux-col-auto ux-col-sm ux-u-mt-xs ux-u-mt-lg-zero"
            label-visibility="s"
            icon="hand-plus-right"
            icon-placement="end"
            data-trigger-async-modal="open,create-new-serice-case"
        >
            ${data.buttonLabel}</ux-button
        >
        ${!data.empty
            ? html`
                  <ux-iws-stateful-filter-search
                      class="ux-col ux-col-lg-auto ux-u-mt-xs ux-u-mt-lg-zero ux-u-mb-zero"
                      name="search"
                      placeholder="${data.searchPlaceholder ||
                      "Suchbegriff eingeben"}"
                      scope="my-service-cases"
                      debug
                  ></ux-iws-stateful-filter-search>
              `
            : ""}
        <ux-iws-async-modal
            name="create-new-serice-case"
            src="mock-data/service-calls/create-service-call.html"
        ></ux-iws-async-modal>
    </div>
</div>`;

const MySoftwareContent = (data) => html`<ux-button
    class="ux-col-12 ux-col-md-auto ux-u-mt-xs ux-u-mt-md-zero ux-u-mb-zero"
>
    ${data.buttonLabel}
</ux-button>`;

const SingleSearchFielContent = (data) => html`<div
    class="ux-col-12 ux-col-lg-auto ux-u-d-flex ux-u-mt-xs ux-u-flex-jc-center ux-u-flex-jc-lg-end ux-u-flex-ai-center"
>
    <ux-iws-stateful-filter-search
        name="search"
        placeholder="${data.searchPlaceholder || "Suchbegriff eingeben"}"
        scope="${data.type === "my-missions"
            ? "mymissions"
            : data.type === "my-orders"
            ? "my-orders"
            : ""}"
        debug
    ></ux-iws-stateful-filter-search>
</div>`;

export const MyMachine = OverviewHeaderIntroRow.bind({});
MyMachine.args = {
    headline: "My Machines",
    type: "my-machine",
    buttonLabel: "Equipment hinzufügen",
};

export const MyOrders = OverviewHeaderIntroRow.bind({});
MyOrders.args = {
    headline: "My Orders",
    type: "my-orders",
};

export const MyServiceCases = OverviewHeaderIntroRow.bind({});
MyServiceCases.args = {
    headline: "My Service Cases",
    type: "my-service-cases",
    buttonLabel: "Create new case",
};

export const MySoftware = OverviewHeaderIntroRow.bind({});
MySoftware.args = {
    headline: "My Software",
    type: "my-software",
    buttonLabel: "To Downloads",
};
